import React, { Component } from 'react';
import { translate } from "react-translate";
import _ from 'lodash'

//IMPORT REDUX
import { connect } from 'react-redux';
import { addPkuidsub, addStripeToken, addStripePopup } from '../../../redux/actions/AppAction'

//IMPORT IMAGES
import firstExtension from '../../../assets/svg/firstExtension.svg';
import ExtensionsNews from '../../../assets/svg/ExtensionsNews.svg';

//IMPORT REACT COMPONENTS
import Checkout from './Checkout.js'

//IMPORT SEMANTIC COMPONENTS
import 'semantic-ui-css/semantic.min.css';
import {
    Button,
    Container,
    Segment,
    Menu,
    Image,
    Dropdown,
    Header,
    List,
    Grid,
    Search,
    Advertisement,
    Icon,
    Divider,
    Table,
    Input,
    Item,
    Modal,
    TextArea,
    Responsive,
    Label,
} from 'semantic-ui-react';

import './extension.css'

import stripe_payment from '../../../assets/img/stripe_payment.png';
import Exit from '../../../assets/svg/Exit.svg';

import API from '../../../services/api';

const fromCentToEuro = amount_euro => amount_euro / 100;

const mapStateToProps = state => ({
    app: state.app
})

const mapActionToProps = ({
    addPkuidsub: addPkuidsub,
    addStripeToken: addStripeToken,
    addStripePopup: addStripePopup
})

class ConnectedExtensionsContentComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sub: [],
            response: null,
            showResults: null,
            error: null,
            hasPaid: false,
            colored: false,
            modal: false,
            subscription: null,
            isLoading: false,
            source: [],
            searchResults: [],
            value: ''
        }

        this.handleSubmitPay = this.handleSubmitPay.bind(this);
        this.setStripeToken = this.setStripeToken.bind(this);
        this.handleClick = this.handleClick.bind(this)
        this.closeModal = this.closeModal.bind(this)
        this.addStripePopup = this.addStripePopup.bind(this)
        this.handleSearchChange = this.handleSearchChange.bind(this)
        this.handleResultSelect = this.handleResultSelect.bind(this)

    }

    setPkuidsub(pkuidsub) {
        this.props.addPkuidsub(pkuidsub)
    }

    setStripeToken(stripe_token) {
        this.props.addStripeToken(stripe_token);
    }

    resetComponent() {
        this.setState({
            isLoading: false,
            searchResults: [],
            showResults: this.state.response,
            value: ''
        })
    }

    convertToSearchModel(response) {
        const { t } = this.props;
        let source = []
        Object.entries(response).map((key, mainindex) => {
            if (key[0] !== 'code' && key[0] !== 'msg') {
                let sourceValue = {
                    title: t(key[1].label),
                    description: t("no_ads_text"),
                    image: API.resourceURL + '/' + key[1].link_picture,
                    price: key[1].amount_euro / 100 + '€',
                    response_key: key[0],
                }
                source.push(sourceValue);
            }
        })

        return source;
    }


    componentWillMount() {
        var self = this;
        this.resetComponent();
        API.getAllSub(this.props.app.token).then((getAllResponse) => {
            var response = getAllResponse.data;
            Object.keys(response).map(function(key, index) {
                if (response[key].code && response[key].code === 'c_profull') {
                    response[key].pro = true
                }
            });
            var subData = {
                id: this.props.app.id
            }
            API.getSub(this.props.app.token, subData).then((res) => {
                let subs = []
                let source = []
                Object.entries(res.data).map((key, mainindex) => {
                    if (key[0] === "code" || key[0] === "msg") {

                    } else {
                        Object.entries(key[1]).map((key, Mainindex) => {
                            if (key[0] === "pkuidsub") {
                                subs[mainindex] = key[1]
                            }
                        })
                    }
                })

                source = self.convertToSearchModel(response)
                self.setState({
                    subscription: subs,
                    response: response,
                    showResults: response,
                    source: source
                });
            });
        }, (getAllError) => {
            self.setState({
                error: getAllError.error
            })
        });
    }

    handleResultSelect(e, { result }) {
        let showResults = {}
        showResults[result.response_key] = this.state.response[result.response_key]
        this.setState({
            value: result.title,
            showResults: showResults
        })
    }

    handleSearchChange(e, { value }) {
        this.setState({
            isLoading: true, value
        })

        setTimeout(() => {
            if (this.state.value.length < 1) return this.resetComponent()

            const re = new RegExp(_.escapeRegExp(this.state.value), 'i')
            const isMatch = result => re.test(result.title)
            let searchResults = _.filter(this.state.source, isMatch)
            let showResults = {}
            for (let i = 0; i < searchResults.length; i++) {
                showResults[searchResults[i].response_key] = this.state.response[searchResults[i].response_key]
            }

            this.setState({
                isLoading: false,
                searchResults: searchResults,
                showResults: showResults
            })
        }, 300)
    }

    handleSubmitPay(event) {
        this.setStripeToken();
        event.preventDefault();
        this.setState({
            modal: false
        })
        var self = this;
        var form = new FormData();
        form.append("fkuidsub", this.props.app.pkuidsub);
        form.append("fkuiduser", this.props.app.id);
        form.append("stripe_token", this.props.app.stripe_token);

        API.createSub(this.props.app.token, form).then((res) => {
            var response = res.data;
            self.setState({
                hasPaid: true,
            })
        });
    }

    handleClick(e, id) {
        e.preventDefault();

        this.addStripePopup(true)
        this.setPkuidsub(id);
    }

    addStripePopup(value) {
        this.props.addStripePopup(value)
    }


    handleClickStripeToken(e, token) {
        e.preventDefault();
        this.setStripeToken(token);
    }

    closeModal() {
        this.addStripePopup(false)
    }


    render() {
        const { t } = this.props;
        const { isLoading, value, searchResults } = this.state
        return (
            <div>
                <Grid stackable id="extension">
                    <Grid.Row columns={2} id="headerSection">
                        <Grid.Column textAlign='middle' width={4}>
                            <Segment basic onClick={this.handleClickReset}>
                                <Item.Image size='mini' src={ExtensionsNews} id="imageSection" />
                                <Item.Content verticalAlign='middle'>
                                    <Item.Header as='h3' id="titleSection">{t("Item1_title")}</Item.Header>
                                </Item.Content>
                            </Segment>
                        </Grid.Column>
                        <Grid.Column verticalAlign='middle' width={12}>
                            <Search id='SearchColumn' input={{ fluid: 'true' }} placeholder={t("filter_sub")}
                                loading={isLoading}
                                onResultSelect={this.handleResultSelect}
                                onSearchChange={_.debounce(this.handleSearchChange, 500, { leading: true })}
                                results={searchResults}
                                value={value}
                                className={this.state.searchResults.length >= 1 ? 'search_bar' : ''}
                                {...this.props}
                            />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns={3} style={{ margin: '20px 0px' }}>
                        {
                            this.state.showResults && this.props.app.token &&
                            Object.entries(this.state.showResults).map((key, mainindex) => {
                                const euro = key[1].amount_euro / 100
                                if (key[0] === 'msg' || key[0] === 'code') {
                                } else {
                                    let check = false
                                    this.state.subscription.map(x => {
                                        if (x == key[1].pkuidsub) {
                                            check = true
                                        }
                                    })

                                    if (check) {
                                        return (

                                            <Grid.Column >
                                                <Segment 
                                                    raised 
                                                    id='testo' 
                                                    textAlign='center' 
                                                    onClick={(e) => this.handleClick(e, key[1].pkuidsub)} 
                                                    className={key[1].pro ? 'proExtension' : ''}
                                                >
                                                    {key[1].pro ? (
                                                        <label className='pro_label'>Pro</label>
                                                    ) : <label/>}

                                                    <Container textAlign='center'>
                                                        <Image centered src={API.resourceURL + '/' + key[1].link_picture} />
                                                        <Item.Header as='h3' verticalAlign='middle' id="testoTitle" className={key[1].pro ? 'pro': ''}>{t(key[1].label)}</Item.Header>
                                                        <Segment basic >
                                                            <p>{t(key[1].label)}</p>
                                                        </Segment>

                                                    </Container>
                                                    <Label id="checkoutBtn" style={{ backgroundColor: "#29ba77" }} className={key[1].pro ? 'pro' : ''}>
                                                        {t("valide")}
                                                    </Label>
                                                </Segment>
                                            </Grid.Column>
                                        )
                                    } else {
                                        return (
                                            <Grid.Column >
                                                <Segment raised id='testo' textAlign='center' onClick={(e) => this.handleClick(e, key[1].pkuidsub)} className={key[1].pro ? 'pro' : ''}>
																										{key[1].pro ? (
																											<label className='pro_label'>Pro</label>
																										) : <label/>}
                                                    <Container textAlign='center'>
                                                        <Image centered src={API.resourceURL + '/' + key[1].link_picture} />
                                                        <Item.Header as='h3' verticalAlign='middle' id="testoTitle" className={key[1].pro ? 'pro' : ''}>{t(key[1].label)}</Item.Header>
                                                        <Segment basic >
                                                            <p>{t(key[1].label)}</p>
                                                        </Segment>

                                                    </Container><Button  size='small' id="checkoutBtn" onClick={(e) => this.handleClick(e, key[1].pkuidsub)} className={key[1].pro ? 'pro' : ''}>{euro} €</Button>

                                                    <Modal
                                                      size='tiny'
                                                      open={this.props.app.stripe}
                                                      onClose={this.closeModal} >

                                                        <Modal.Header id="modalHeader">

                                                          <Grid>
                                                              <Grid.Row>
                                                                  <Grid.Column textAlign='center'>
                                                                      <Image
                                                                        onClick={this.closeModal}
                                                                        src={Exit}
                                                                        floated='right'
                                                                        id="modalExit" />
                                                                      <Header
                                                                        id="modalTitle"
                                                                        as='h2'
                                                                        textAlign='center'>
                                                                        {t("Header1_title")}
                                                                      </Header>
                                                                  </Grid.Column>
                                                              </Grid.Row>
                                                          </Grid>

                                                        </Modal.Header>

                                                        <Modal.Content >
                                                            <Image style={{ width: '16em', height: '8em', marginTop: '2em', marginBottom: '2em' }} centered src={stripe_payment} />

                                                            <Grid textAlign='center'>
                                                                <Grid.Row columns={1}>
                                                                    <Grid.Column id="modalContentText">
                                                                        {t(key[1].label)}
                                                                    </Grid.Column>
                                                                </Grid.Row>
                                                            </Grid>


                                                            <Checkout price={euro + ' ' + '€'} />
                                                        </Modal.Content>
                                                    </Modal>

                                                </Segment>
                                            </Grid.Column>
                                        )
                                    }

                                }
                            })
                        }
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}

const ExtensionsContentComponent = connect(mapStateToProps, mapActionToProps)(ConnectedExtensionsContentComponent);
export default translate("ExtensionContentComponent")(ExtensionsContentComponent);



// WEBPACK FOOTER //
// ./src/components/Protected/Extension/ExtensionContentComponent.js